var buildNutritionTabHtml = function (nutritionObject) {
    return '<div class="nutrition-information-tab" style="background-color: ' + nutritionObject.backgroundColor + ';">' +
        '<img class="nutrition-product-image" src="' + nutritionObject.productImage + '" />' +
        '<span class="product-name">' + nutritionObject.name + '</span>' +
        '<img class="arrow-image" src="//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/white-arrow-right.png?v=175301480440964253151603356244" />' +
    '</div>';
};

var buildNutritionHtml = function (nutritionObject) {
    if(!nutritionObject) {
        return '';
    }

    if(
        nutritionObject.include && 
        typeof nutritionObject.include === 'object' && 
        nutritionObject.include.length > 0
    ) {
        var tabs = '';
        var response = '';
        for(var i in nutritionObject.include) {
            tabs += buildNutritionTabHtml(
                productSettings[nutritionObject.include[i]]
            );
            response += buildNutritionHtml(
                productSettings[nutritionObject.include[i]]
            );
        }
        return '<div class="tab-container">' + tabs + '</div><div class="multi-nutrition-container">' + response + '</div>';
    }

    var ingriedients = '';
    for(var i in nutritionObject.ingredients) {
        ingriedients += '<li>' + nutritionObject.ingredients[i] + '</li>';
    }

    var icons = '';

    icons += '<div class="nutrition-icon"><div class="top-section">' + nutritionObject.protein + 'g</div><div class="bottom-section">PROTEIN</div></div>';
    icons += '<div class="nutrition-icon"><div class="top-section">' + nutritionObject.sugar + 'g</div><div class="bottom-section">SUGAR</div></div>';

    for(var i in nutritionObject.icons) {
        icons += getNutritionIcon(nutritionObject.icons[i]);
    }

    return '<div class="nutrition-information" style="background-color: ' + nutritionObject.backgroundColor + ';">' +
                '<div class="nutrition-text">' + 
                    '<span class="product-name">' + nutritionObject.name + '</span>' +
                    '<img class="close-nutrition-popup" src="//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon-close-white.png?v=147049480740447835001603356157" />' +
                    '<div class="grid">' +
                        '<div class="grid__item large--one-half small--one-half">' +
                            '<img class="nutrtion-product-image" alt="Product image" src="' + nutritionObject.productImage + '" />' +
                        '</div>' +
                        '<div class="grid__item large--one-half small--one-half">' +
                            '<ul class="nutrition-ingredients">' +
                                ingriedients + 
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                    '<div class="nutrition-icons">' + icons + '</div>' +
                '</div>' +
                '<div class="nutrition-image">' +
                    '<img alt="Nutrition facts label" src="' + nutritionObject.nutritionImage + '" />' +
                '</div>' +
                '<div class="clearfix"></div>' +
            '</div>';
};

var getNutritionIcon = function (type) {
    switch(type) {
        case 'gluten-free':
            return "<div class=\"nutrition-icon\"><div class=\"top-section\"><img alt=\"Product is gluten free\" src=\"//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon_glutenfree.png?v=6865484481874337161603356161\" /></div><div class=\"bottom-section\">GLUTEN FREE</div></div>";
        case 'dairy-free':
            return "<div class=\"nutrition-icon\"><div class=\"top-section\"><img alt=\"Product is dairy free\" src=\"//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon_dairyfree.png?v=183450771495507710441603356160\" /></div><div class=\"bottom-section\">DAIRY FREE</div></div>";
        case 'contains-peanuts':
            return "<div class=\"nutrition-icon\"><div class=\"top-section\"><img alt=\"Product contains nuts\" src=\"//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon_containsnuts.png?v=81646701329137448101603356159\" /></div><div class=\"bottom-section\">CONTAINS NUTS</div></div>";
        case 'soy-free':
            return "<div class=\"nutrition-icon\"><div class=\"top-section\"><img alt=\"Product is soy free\" src=\"//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon_soyfree.png?v=43686970706225390641603356163\" /></div><div class=\"bottom-section\">SOY FREE</div></div>";
        case 'tree-nut-free':
            return "<div class=\"nutrition-icon\"><div class=\"top-section\"><img alt=\"Product is tree nut free\" src=\"//cdn.shopify.com/s/files/1/0403/7043/8305/t/15/assets/icon_treenutfree.png?v=69718755818761266051603356164\" /></div><div class=\"bottom-section\">TREE NUT FREE</div></div>";
    }
};